<template>
  <div>
    <!--    기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'alert', label: '알림 대상자 선택' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    장비정보-->
    <table-equipment
      class="mt-5"
      :list="form.equipmentList"
      @updateList="updateList"
      :isPrint="isPrint"
      :isReadonly="board.readonly"
    ></table-equipment>

    <!--    점검대상-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot"></i> 점검대상</h5>
      </vs-col>
    </vs-row>

    <div class="grid xl:grid-cols-8 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-2 flex items-center">
        <!--        체크 1-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_1"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_1 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_1"
            ></vs-checkbox>
            {{ inspectionTitle_1 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 2-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_2"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_2 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_2"
            ></vs-checkbox>
            {{ inspectionTitle_2 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 3-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_3"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_3 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_3"
            ></vs-checkbox>
            {{ inspectionTitle_3 }}
          </span>
        </div>
      </div>
      <div class="col-span-2 flex items-center">
        <!--        체크 4-->
        <div v-if="isPrint" class="flex items-center">
          <div
            v-if="form.check_4"
            style="background: #200c63"
            class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2"
          >
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div
            v-else
            style="border: 2px solid rgb(180, 180, 180)"
            class="w-5 h-5 rounded-sm mr-2"
          ></div>
          <span class="flex-1">
            {{ inspectionTitle_4 }}
          </span>
        </div>
        <div v-else>
          <span class="flex">
            <vs-checkbox
              :readonly="board.readonly"
              v-model="form.check_4"
            ></vs-checkbox>
            {{ inspectionTitle_4 }}
          </span>
        </div>
      </div>
    </div>

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_1"
      :list="form.inspectList_1"
      @update-list-check="updateListCheck_1"
      v-if="form.check_1"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_2"
      :list="form.inspectList_2"
      @update-list-check="updateListCheck_2"
      v-if="form.check_2"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_3"
      :list="form.inspectList_3"
      @update-list-check="updateListCheck_3"
      v-if="form.check_3"
    />

    <table-inspect
      class="mt-5"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspectionTitle_4"
      :list="form.inspectList_4"
      @update-list-check="updateListCheck_4"
      v-if="form.check_4"
    />

    <!--    사진대지-->
    <PhotoUploadGridModule
      :row-count="2"
      :grid-count="2"
      v-model="form.photoList"
      :isPrint="isPrint"
      :readonly="board.readonly"
      section-title="사진대지"
      placeholder="신축현장 점검"
    />

    <!--    파일첨부-->
    <file-upload-module
      id="fileList"
      class="w-full mt-4"
      v-model="form.fileList"
      :isPrint="isPrint"
      :readonly="board.readonly"
    ></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableEquipment from "@/components/TableEquipment";
import DisasterClassSelector from "@/components/selector/DisasterClassSelector";

export default {
  components: {
    FileUploadModule,
    TableInspect,
    TableEquipment,
    DisasterClassSelector,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (
          !this.form ||
          !this.form.inspectList_1 ||
          this.form.inspectList_1.length === 0
        ) {
          this.form.inspectList_1 = this.inspectTable_1;
        }
        if (
          !this.form ||
          !this.form.inspectList_2 ||
          this.form.inspectList_2.length === 0
        ) {
          this.form.inspectList_2 = this.inspectTable_2;
        }
        if (
          !this.form ||
          !this.form.inspectList_3 ||
          this.form.inspectList_3.length === 0
        ) {
          this.form.inspectList_3 = this.inspectTable_3;
        }
        if (
          !this.form ||
          !this.form.inspectList_4 ||
          this.form.inspectList_4.length === 0
        ) {
          this.form.inspectList_4 = this.inspectTable_4;
        }
        if (
          !this.form ||
          !this.form.inspectList_5 ||
          this.form.inspectList_5.length === 0
        ) {
          this.form.inspectList_5 = this.inspectTable_5;
        }
        if (
          !this.form ||
          !this.form.inspectList_6 ||
          this.form.inspectList_6.length === 0
        ) {
          this.form.inspectList_6 = this.inspectTable_6;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.form.inspectionTitle = `${
          value.check_1 ? this.inspectionTitle_1 : ""
        }
            ${value.check_2 ? this.inspectionTitle_2 : ""}
            ${value.check_3 ? this.inspectionTitle_3 : ""}
            ${value.check_4 ? this.inspectionTitle_4 : ""}`;

        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      inspectionTitle_1: "공통",
      inspectionTitle_2: "용접·용단 작업 등 (화재·폭발)",
      inspectionTitle_3: "가설전기 및 전기공사 (감전)",
      inspectionTitle_4: "밀폐공간 작업 (질식·중독)",

      form: {
        inspectionTitle: "",
        stdInfo: {},
        photoList: [],
        check_1: true,
        check_2: false,
        check_3: false,
        check_4: false,
        fileList: [],
        equipmentList: [],
        inspectList_1: [],
        inspectList_2: [],
        inspectList_3: [],
        inspectList_4: [],
      },
    };
  },
  computed: {
    inspectTable_1() {
      return [
        {
          id: 1,
          label:
            "작업현장 내 유해하거나 위험한 장소·시설·물질에 대한 경고, 비상시에 대처하기 위한 지시·안내 등의 표지를 작업자가 알아보기 쉽도록 부착하여야 한다.",
          is_checked: "",
          title: "안전보건 표지",
        },
        {
          id: 2,
          label:
            "안전보건표지는 각각 위험을 경고하는 그림과 문구를 포함하고 있어야 한다.",
          is_checked: "",
          title: "안전보건 표지",
        },
        {
          id: 3,
          label:
            "표지의 제작은 금지, 경고, 지시, 안내 등 표지의 용도에 맞는 모형, 색상, 심볼, 문구를 사용한다",
          is_checked: "",
          title: "안전보건 표지",
        },
        {
          id: 4,
          label:
            "현장에 설치된 안전표지들이 장애물로부터 시야를 가리지 않도록 해야 한다.",
          is_checked: "",
          title: "안전보건 표지",
        },
        {
          id: 5,
          label:
            "경고표지는 강화 알루미늄, 강화 플라스틱, PVC 등 쉽게 파손되거나 변질되지 않는 소재로 제작되어야 하고, 현장의 상황을고려하여 반사되거나 발광하게 할 수 있다.",
          is_checked: "",
          title: "안전보건 표지",
        },
        {
          id: 6,
          label: "작업별 유해·위험 요인을 파악하여 안전한 작업계획을 수립한다.",
          is_checked: "",
          title: "작업 전 작업",
        },
        {
          id: 7,
          label:
            "작업을 수행하는 작업자에게 각 작업의 유해·위험요인 및 위험상황 발생 시 대처요령을 주지시킨다. ",
          is_checked: "",
          title: "작업 전 작업",
        },
        {
          id: 8,
          label:
            "각 유해·위험작업에 대한 관리자를 지정하고, 관리자의 지도·감독 하에 작업을 수행한다.",
          is_checked: "",
          title: "작업 전 작업",
        },
        {
          id: 9,
          label:
            "유해·위험 작업별 필요한 보호구를 파악하고, 작업자에게 지급·착용하도록 한다.",
          is_checked: "",
          title: "보호구",
        },
      ];
    },
    inspectTable_2() {
      return [
        {
          id: 1,
          label: "화재위험작업에 대한 작업계획을 수립한다.",
          is_checked: "",
          title: "작업 전 확인사항",
        },
        {
          id: 2,
          label: "작업장 내 위험물, 가연물의 사용·보관 현황을 파악한다.",
          is_checked: "",
          title: "작업 전 확인사항",
        },
        {
          id: 3,
          label:
            "위험물질로 인한 응급상황이 발생했을 때 필요한 행동에 대한 정보를 미리 준비하고 있어야 한다.",
          is_checked: "",
          title: "작업 전 확인사항",
        },
        {
          id: 4,
          label:
            "작업현장에 허가받은 위험물의 종류별 기준량 이상이 되면 지역 소방기관과 관계기관에 신고해야 한다.",
          is_checked: "",
          title: "작업 전 확인사항",
        },
        {
          id: 5,
          label:
            "소방서로부터 허가받은 위험물 제조소 또는 저장소 자료를 토대로 현장에 위험물의 종류별로 기준 이상의 위험물이 존재하거나 앞으로 존재하게 될것인지의 여부를\n" +
            "      판단해야 한다.",
          is_checked: "",
          title: "작업 전 확인사항",
        },
        {
          id: 6,
          label: "작업자에 대해 화재예방 및 피난 교육 등을 실시한다.",
          is_checked: "",
          title: "작업 전 확인사항",
        },
        {
          id: 7,
          label: "화재위험작업 대상 작업자에게 특별안전보건교육을 실시한다.",
          is_checked: "",
          title: "작업 전 확인사항",
        },
        {
          id: 8,
          label:
            "산소, LPG 등 가스 용기는 전도 위험이 없는 곳에 보관하며, 사용 전 또는 사용 중인 용기와 그 밖의 용기를 명확히 구별하여 보관한다.",
          is_checked: "",
          title: "가스 등의 가연물의 관리",
        },
        {
          id: 9,
          label:
            "작업을 중단하거나 마치고 작업장소를 떠날 경우에는 가스 등의 공급구의 밸브나 콕을 잠근다.",
          is_checked: "",
          title: "가스 등의 가연물의 관리",
        },
        {
          id: 10,
          label:
            "인화성 가스 및 산소를 사용하여 금속을 용접·용단하는 경우, 지정된 자격증*의 보유 여부를 확인한다.\n" +
            "      *전기용접기능사, 특수용접기능사 및 가스용접기능사보 등",
          is_checked: "",
          title: "용접·용단 작업",
        },
        {
          id: 11,
          label:
            "작업자의 대피를 유도하는 업무만을 담당하는 화재감시자를 지정하여 용접·용단 작업 장소에 배치하여야 한다.",
          is_checked: "",
          title: "용접·용단 작업",
        },
        {
          id: 12,
          label:
            "주변 가연성물체에 불꽃이 튀지 않도록 용접불티 비산방지덮개, 용접방화포 등을 설치 및 소화기구를 비치하여 작업한다.",
          is_checked: "",
          title: "용접·용단 작업",
        },
        {
          id: 13,
          label:
            "불꽃이 발생될 우려가 있는 작업을 하는 경우 주변에 가연물*, 인화성 액체는 화재위험이 없는 장소에 별도로 보관·저장한다.\n" +
            "*합성섬유, 합성수지, 면, 양모, 천조각, 톱밥, 짚, 종이류 또는 인화성 액체 등",
          is_checked: "",
          title: "용접·용단 작업",
        },
      ];
    },
    inspectTable_3() {
      return [
        {
          id: 1,
          label:
            "감전위험이 있는 전기 기계·기구 또는 전로의 설치·해체·정비·점검 등의 작업을 하는 하는 경우 작업자의 자격을 확인한다.",
          is_checked: "",
          title: "자격 및 보호구의 확인",
        },
        {
          id: 2,
          label:
            "감전의 위험이 있는 작업에 종사하는 경우 절연용 보호구를 지급하고 작업자에게 착용하도록 한다.",
          is_checked: "",
          title: "자격 및 보호구의 확인",
        },
        {
          id: 3,
          label:
            "가공전로에 근접하여 비계를 설치하는 경우에는 가공전로를 이설하거나 가공전로에 절연용 방호구를 장착하는 등 가공전로와의 접촉을 방지하기 위해조치 한다.",
          is_checked: "",
          title: "가공전로 및 임시 수전설비",
        },
        {
          id: 4,
          label:
            "임시 수전설비의 주변은 관계 작업자가 아닌 사람의 출입을 금지하고, 위험표시 등의 방법으로 방호를 강화한다.",
          is_checked: "",
          title: "가공전로 및 임시 수전설비",
        },
        {
          id: 5,
          label:
            "가설 배전반·분전반은 충전부가 노출되지 않도록 폐쇄형 외함이 있는 구조로 설치한다. ",
          is_checked: "",
          title: "배전반·분전반 설치 및 관리",
        },
        {
          id: 6,
          label:
            "충전부는 충분한 절연효과가 있는 방호망이나 절연덮개를 설치한다.",
          is_checked: "",
          title: "배전반·분전반 설치 및 관리",
        },
        {
          id: 7,
          label:
            "분전반 등 전기 기계·기구의 금속제 외함, 금속제 외피 및 철대는 접지를 실시한다.",
          is_checked: "",
          title: "배전반·분전반 설치 및 관리",
        },
        {
          id: 8,
          label:
            "배선 또는 이동전선의 절연피복이 손상되거나 노화됨으로 인한 감전의 위험을 방지하기 위한 조치를 하여야 한다.",
          is_checked: "",
          title: "현장 이동식 케이블(전선) 관리",
        },
        {
          id: 9,
          label:
            "습윤한 장소의 이동전선 및 부속 접속기구는 충분한 절연효과가 있는 것을 사용한다.",
          is_checked: "",
          title: "현장 이동식 케이블(전선) 관리",
        },
        {
          id: 10,
          label:
            "통로바닥에 전선 또는 이동전선 등을 설치하여 사용하지 않도록 관리한다.",
          is_checked: "",
          title: "현장 이동식 케이블(전선) 관리",
        },
        {
          id: 11,
          label:
            "코드와 플러그를 접속하여 사용하는 비충전 금속체의 기계·기구의 접지를 확인한다.",
          is_checked: "",
          title: "이동식 전기기계 기구사용",
        },

        {
          id: 12,
          label:
            "휴대형 또는 이동형 전동기계의 전원에 누전차단기를 설치하고 그 작동여부를 점검한다.",
          is_checked: "",
          title: "이동식 전기기계 기구사용",
        },

        {
          id: 13,
          label:
            "누전차단기는 분기회로 또는 전기기계·기구마다, 배전반 및 분전반 등 누전차단기의 파손을 예방할 수 있는 장소에 접속한다.",
          is_checked: "",
          title: "이동식 전기기계 기구사용",
        },
      ];
    },
    inspectTable_4() {
      return [
        {
          id: 1,
          label:
            "사업장 내 밀폐공간의 위치를 파악하고, 밀폐공간의 질식·중독을 일으킬 수 있는 요인*을 파악하여 밀폐공간 작업 프로그램을 수립한다.\n" +
            "       *산소결핍, 황화수소, 일산화탄소, 이산화탄소 등",
          is_checked: "",
          title: "작업 전 확인사항",
        },
        {
          id: 2,
          label:
            "산소 및 유해가스 측정기, 환기팬, 공기호흡기, 송기마스크의 보유여부를 확인한다.",
          is_checked: "",
          title: "작업 전 확인사항",
        },
        {
          id: 3,
          label:
            "콘크리트 보온양생이 필요한 경우, 갈탄·숯탄 등 연료 대신 전기열풍기를 사용한다.",
          is_checked: "",
          title: "작업 시 안전조치",
        },
        {
          id: 4,
          label:
            "밀폐공간 작업 전, 작업 중 산소 및 유해가스 농도를 측정하고 적정공기 상태인지 확인한다.\n" +
            "\t① 산 소 : 18.0 ~ 23.5%  ② 황화수소 : 10 ppm 미만 \n" +
            "\t③ 탄산가스(이산화탄소) : 1.5% 미만  ④ 일산화탄소 : 30 ppm미만",
          is_checked: "",
          title: "작업 시 안전조치",
        },
        {
          id: 5,
          label:
            "적정공기 상태가 아닌 경우 작업장을 환기시키거나, 작업자에게 공기호흡기 또는 송기마스크를 지급하여 착용하도록 한다.",
          is_checked: "",
          title: "작업 시 안전조치",
        },
        {
          id: 6,
          label: "작업 전과 작업 중에 환기팬을 이용하여 환기한다.",
          is_checked: "",
          title: "작업 시 안전조치",
        },
        {
          id: 7,
          label:
            "밀폐공간 입구에는 출입금지 표지를 부착하고 작업자의 무단출입을 금지하며, 밀폐공간 외부에 감시인을 배치한다.",
          is_checked: "",
          title: "작업 시 안전조치",
        },
        {
          id: 8,
          label: "밀폐공간에 입장시킬 때와 퇴장시킬 때마다 인원을 점검한다.",
          is_checked: "",
          title: "작업 시 안전조치",
        },
        {
          id: 9,
          label:
            "사업장내 밀폐공간의 위치, 작업 전 작업자와 감시인에게 안전작업하는 방법을 교육한다.\n" +
            "       *유해가스 측정, 환기설비 가동, 보호구 착용, 사고시 응급조치, 구조요청 절차 등",
          is_checked: "",
          title: "안전교육",
        },
        {
          id: 10,
          label:
            "밀폐공간에서 사고 발생 시 119 구조대가 오기 전까지는 공기호흡기나 산소마스크를 착용하지 않은 상태에서는 절대 구조하러 들어가지 않도록 교육한다.",
          is_checked: "",
          title: "안전교육",
        },
      ];
    },
  },
  methods: {
    updateList(list) {
      this.form.equipmentList = list;
    },
    updateListCheck_1(indexRows, text) {
      this.form.inspectList_1[indexRows].is_checked = text;
    },
    updateListCheck_2(indexRows, text) {
      this.form.inspectList_2[indexRows].is_checked = text;
    },
    updateListCheck_3(indexRows, text) {
      this.form.inspectList_3[indexRows].is_checked = text;
    },
    updateListCheck_4(indexRows, text) {
      this.form.inspectList_4[indexRows].is_checked = text;
    },
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 15px;
}

/* uploaded File */
.h-upload {
  height: 470px;
}
.upload-content {
  border: $border;
  &:last-child {
    border-left: none;
  }
  &__title {
    height: 54px;
    line-height: 54px;
    text-align: center;
    background: #fafafa;
    border-bottom: $border;
  }
  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__file {
    height: calc(100% - 54px);
    width: 100%;
    padding: 14px;
  }
}
</style>
